import React from "react";
import Image from "react-bootstrap/Image";
import {Heading} from "../../page/Title";

interface ShopperFormHeadingInterface {
  headingText: string,
  logoSrc: string,
}

/**
 * @param headingText
 * @param logoSrc
 *
 * @returns {JSX.Element}
 *
 * @constructor
 */
const ShopperFormHeading = ({headingText, logoSrc}: ShopperFormHeadingInterface) => {
  if (!headingText && logoSrc) {
    throw new Error('One of headingText or logoSrc variable at least must defined for ShopperFormHeading component')
  }

  return (
    <>
      {
        ((logoSrc) && <Image src={logoSrc} className="align-self-start mb-3" style={{maxHeight: '50px'}} />) ||
        ((headingText) && <Heading title={headingText} headingLevel={3} className="h5" />)
      }
    </>
  )
}

export default ShopperFormHeading
